import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    // Management surface — listing, uploading and deleting. Sign-in required.
    path: '',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./projects/projects.component').then((m) => m.ProjectsComponent),
    title: 'Demo Projects — Vizipp Studio',
  },
  {
    // Shared demo preview — intentionally public, no guard.
    path: 'preview/:id',
    loadComponent: () =>
      import('./preview/preview.component').then((m) => m.PreviewComponent),
  },
  { path: '**', redirectTo: '' },
];
